// ALIVEA — script propio. Un init por componente, todo detrás de comprobaciones
// de existencia para que el mismo archivo sirva en cualquier página.
(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".al-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("al-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("al-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: si por lo que sea el observer no dispara para algún
    // elemento (viewport raro, carga lenta, etc.), no lo dejamos oculto para siempre.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add("al-visible"); });
    }, 1500);
  }

  function initAccordion() {
    var items = document.querySelectorAll(".al-acc-item");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector(".al-acc-btn");
      var panel = item.querySelector(".al-acc-panel");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("al-acc-open");
        item.closest(".al-acordeon")?.querySelectorAll(".al-acc-item.al-acc-open").forEach(function (open) {
          if (open !== item) {
            open.classList.remove("al-acc-open");
            var p = open.querySelector(".al-acc-panel");
            if (p) p.style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove("al-acc-open");
          panel.style.maxHeight = null;
        } else {
          item.classList.add("al-acc-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll(".al-countup[data-al-target]");
    if (!els.length) return;
    function animate(el) {
      var target = parseFloat(el.dataset.alTarget) || 0;
      var suffix = el.dataset.alSuffix || "";
      var dur = 1200;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.textContent = el.dataset.alTarget + (el.dataset.alSuffix || ""); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll("[data-al-galeria]").forEach(function (galeria) {
      var main = galeria.querySelector("[data-al-galeria-principal]");
      var thumbs = galeria.querySelectorAll("[data-al-galeria-thumb]");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-al-full");
          if (!full) return;
          main.src = full;
          thumbs.forEach(function (t) { t.classList.remove("al-thumb-activo"); });
          thumb.classList.add("al-thumb-activo");
        });
      });
    });
  }

  // Selector de variantes: localiza la variante por combinación de opciones y
  // actualiza precio + input oculto + estado agotado.
  function initVariantes() {
    document.querySelectorAll("[data-al-form-producto]").forEach(function (form) {
      var dataEl = form.querySelector("[data-al-variantes-json]");
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector("[data-al-precio]");
      var compareEl = form.querySelector("[data-al-precio-comparado]");
      var addBtn = form.querySelector("[data-al-add-btn]");
      var selects = form.querySelectorAll("[data-al-opcion]");
      if (!dataEl || !idInput || !selects.length) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      function actualizar() {
        var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
        var variante = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!variante) return;
        idInput.value = variante.id;
        // Los precios ya vienen formateados desde Liquid (respetan moneda/idioma
        // de la tienda) — el JS solo decide qué mostrar, no recalcula importes.
        if (priceEl) priceEl.textContent = variante.price_formatted;
        if (compareEl) {
          if (variante.on_sale) {
            compareEl.textContent = variante.compare_at_price_formatted;
            compareEl.style.display = "";
          } else {
            compareEl.style.display = "none";
          }
        }
        if (addBtn) {
          addBtn.disabled = !variante.available;
          addBtn.textContent = variante.available ? addBtn.dataset.alTextoDisponible : addBtn.dataset.alTextoAgotado;
        }
      }
      selects.forEach(function (s) { s.addEventListener("change", actualizar); });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    initReveal();
    initAccordion();
    initCountUp();
    initGaleria();
    initVariantes();
  });
})();
